import { useState, useRef } from 'react';
import { PencilSimple, Check } from '@phosphor-icons/react';
import { twMerge } from 'tailwind-merge';
import PropTypes from 'prop-types';

export const Text = ({
  AS = 'div',
  onEditComplete = () => {},
  textConent = '',
  EditModeOnIcon = (
    <Check
      size={32}
      className="text-brand-success-800 cursor-pointer"
      weight="bold"
    />
  ),
  EditModeOffIcon = <PencilSimple size={32} className="cursor-pointer" />,
  textContentClassName,
  wrapperClassName,
  buttonClassName,
  name,
  editModeDefault = false,
  editActiveClassName,
  editActiveWrapperClassName,
  isEditable = true,
  direction = 'row',
  activeOnElementClick = false,
  doReset = false,
  activeText = '',
}) => {
  const contentRef = useRef(null);
  const [isEditModeOn, setIsEditModeOn] = useState(editModeDefault);
  const handleEditModeOn = () => {
    setIsEditModeOn(true);
    contentRef.current.innerText = activeText;
    contentRef.current.focus();
  };
  const handleEditModeOff = () => {
    onEditComplete({ name, value: contentRef.current.innerText });
    setIsEditModeOn(false);
    if (doReset) {
      contentRef.current.innerText = textConent;
    }
  };
  const handleEditMode = () => {
    if (isEditModeOn) {
      handleEditModeOff();
    } else {
      handleEditModeOn();
    }
  };
  const onWrapperClick = () => {
    if (activeOnElementClick && !isEditModeOn) {
      handleEditMode();
    }
  };
  return (
    <div
      className={twMerge(
        'flex gap-4 items-start outline-none',
        `flex-${direction}`,
        wrapperClassName,
        activeOnElementClick && !isEditModeOn && `cursor-pointer`,
        isEditModeOn && editActiveWrapperClassName
      )}
      tabIndex={0}
      onClick={onWrapperClick}
    >
      <AS
        ref={contentRef}
        className={twMerge(
          textContentClassName,
          isEditModeOn && editActiveClassName
        )}
        contentEditable={isEditModeOn}
        suppressContentEditableWarning={true}
        autoFocus
      >
        {textConent}
      </AS>
      {isEditable && (
        <button
          type="button"
          className={twMerge(buttonClassName)}
          onClick={handleEditMode}
        >
          {isEditModeOn ? EditModeOnIcon : EditModeOffIcon}
        </button>
      )}
    </div>
  );
};
Text.propTypes = {
  AS: PropTypes.string,
  onEditComplete: PropTypes.func,
  textConent: PropTypes.string,
  EditModeOnIcon: PropTypes.element,
  EditModeOffIcon: PropTypes.element,
  name: PropTypes.string,
  editModeDefault: PropTypes.bool,
  buttonClassName: PropTypes.string,
  isEditable: PropTypes.bool,
  textContentClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  editActiveClassName: PropTypes.string,
  editActiveWrapperClassName: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'row-reverse', 'col', 'col-reverse']),
  activeOnElementClick: PropTypes.bool,
  doReset: PropTypes.bool,
  activeText: PropTypes.string,
};
